import React from 'react';
import { Link } from 'react-router-dom';
import { Cloud, ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#1a1a2e]">
      {/* Header */}
      <header className="glass-header fixed top-0 left-0 right-0 z-50 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Cloud className="w-8 h-8 text-[#39FF14]" />
            <span className="font-bold text-xl text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
              FART BUTTON
            </span>
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-[#A0A0C0] hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 
            className="text-4xl font-black text-white mb-8"
            style={{ fontFamily: 'Unbounded, sans-serif' }}
          >
            Privacy Policy
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#A0A0C0]">
            <p className="text-lg">
              Last updated: January 2026
            </p>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                1. Introduction
              </h2>
              <p>
                Welcome to Fart Button Madness ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you use our mobile application.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                2. Information We Collect
              </h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-white">Usage Data:</strong> Information about how you use the app, including fart counts, badges earned, and game scores.</li>
                <li><strong className="text-white">Device Information:</strong> Device type, operating system, and unique device identifiers.</li>
                <li><strong className="text-white">Analytics Data:</strong> Crash reports and performance data to improve the app.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                3. How We Use Your Information
              </h2>
              <p>We use collected information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and maintain the app's features</li>
                <li>Track your progress, badges, and leaderboard rankings</li>
                <li>Improve and optimize the app experience</li>
                <li>Send you updates and notifications (with your consent)</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                4. Data Sharing
              </h2>
              <p>
                We do not sell your personal data. We may share anonymized, aggregated data with third-party analytics providers to improve our services. Leaderboard data (username and scores) may be visible to other users.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                5. Data Security
              </h2>
              <p>
                We implement appropriate security measures to protect your data. However, no method of electronic transmission or storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                6. Children's Privacy
              </h2>
              <p>
                Fart Button Madness is intended for users of all ages. We do not knowingly collect personal information from children under 13 without parental consent. If you believe we have collected such information, please contact us.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                7. Your Rights
              </h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Request deletion of your data</li>
                <li>Opt out of analytics tracking</li>
                <li>Request a copy of your data</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                8. Changes to This Policy
              </h2>
              <p>
                We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                9. Contact Us
              </h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <Link to="/contact" className="text-[#39FF14] hover:underline">
                  our contact page
                </Link>.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-white/10">
        <div className="max-w-7xl mx-auto text-center text-[#A0A0C0] text-sm">
          © 2026 Fart Button Madness. Every fart is unique!
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
